// extracted by mini-css-extract-plugin
export default {"main":"Main_main__gwV03","title":"Main_title__jMINB","evacuateButton":"Main_evacuateButton__SwDXH","menuButton":"Main_menuButton__eVguo"};